import Content from 'Components/Layouts/layout/Content';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getUserData } from 'store/selectors/user';
import { useGetFeedbackGroupQuery, useGetSurveyQuery } from 'store/services/feedbackGroup';
import Breadcrumbs from 'style-guide/Breadcrumbs';
import SurveyQuestionAnswer from 'views/LearningCommunity/Categories/SurveySection/SurveyQuestionAnswer';
import CreateContent from './CreateContent';
import CreateSurveySideBar from './CreateSurveySideBar';
import CreateSurveyWrapper from './style/CreateSurveyWrapper';
import SurveyHeader from './SurveyHeader';

const CreateSurvey = () => {
  const { surveyId, seriesName } = useParams();
  const { data } = useGetSurveyQuery({ surveyId });
  const [previewData, setPreviewData] = useState({});
  const [isPreview, setIsPreview] = useState(false);
  const [surveyState, setSurveyState] = useState();
  const user = useSelector(getUserData);
  const { data: newData } = useGetFeedbackGroupQuery(
    { groupId: +seriesName, userId: user.id },
    { skip: !surveyId || !user?.id }
  );
  const items = [
    {
      label: 'Sample Volume',
      key: 1,
    },
    {
      label: 'Sample Chapter',
      key: 2,
    },
    {
      label: 'Survey',
      key: 3,
    },
  ];

  const feedbackGroups = surveyState?.map(
    (group) =>
      ({
        legend: group.legend,
        id: group.id,
      } || [])
  );
  const currentData = surveyState?.find((current) => current.id === +seriesName);

  return (
    <CreateSurveyWrapper>
      <SurveyHeader
        isPreview={isPreview}
        setIsPreview={setIsPreview}
        name={data?.title}
        surveyState={surveyState}
        newData={newData}
        currentData={currentData}
      />
      {isPreview ? (
        <div className='d-flex'>
          <CreateSurveySideBar isPreview={isPreview} setSurveyState={setSurveyState} />
          <Content className='mh--16 content'>
            <div className='row ph--16'>
              <Breadcrumbs items={items} className='pv--24 breadcrumbs-block' />
              <div className='overflow content-overflow'>
                <SurveyQuestionAnswer
                  chapterId={5}
                  currentData={currentData}
                  feedbackGroups={feedbackGroups}
                  surveyState={surveyState}
                />
              </div>
            </div>
          </Content>
        </div>
      ) : (
        <div className='d-flex'>
          <CreateSurveySideBar setSurveyState={setSurveyState} />
          <CreateContent
            surveyState={surveyState}
            previewData={previewData}
            setPreviewData={setPreviewData}
            setSurveyState={setSurveyState}
          />
        </div>
      )}
    </CreateSurveyWrapper>
  );
};
export default CreateSurvey;
